import themeActions from './actions';

export default (state = {}, action) => {
  switch (action.type) {
    case themeActions.GET_SUCCESS:
    case themeActions.GET_FAILED:
      return action.payload.data;
    default:
      return state;
  }
};
